import { render, staticRenderFns } from "./CustomHeader.vue?vue&type=template&id=029411c4&scoped=true&"
import script from "./CustomHeader.vue?vue&type=script&lang=ts&"
export * from "./CustomHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomHeader.vue?vue&type=style&index=0&id=029411c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029411c4",
  null
  
)

export default component.exports